export function emitter() {
	const listenersLists = {};
	const instance = {
		on(event, ...listeners) {
			listenersLists[event] = (listenersLists[event] || []).concat(listeners);
			return instance;
		},
		dispatch(event, ...args) {
			const listeners = listenersLists[event] || [];
			for (const listener of listeners) {
				listener(...args);
			}
			return instance;
		},
		off(event, ...listeners) {
			if (event === undefined) {
				Object.keys(listenersLists).forEach(ev => instance.off(ev));
			} else {
				const list = listenersLists[event] || [];
				listenersLists[event] = listeners.length ? list.filter(listener => !listeners.includes(listener)) : [];
			}
			return instance;
		}
	};
	return instance;
}

export const proxyListener = eventMap => ({emitter}) => {
	const proxy = {};
	const eventListeners = {};

	for (const ev of Object.keys(eventMap)) {
		const method = eventMap[ev];
		eventListeners[ev] = [];
		proxy[method] = function (...listeners) {
			eventListeners[ev] = eventListeners[ev].concat(listeners);
			emitter.on(ev, ...listeners);
			return proxy;
		};
	}

	return Object.assign(proxy, {
		off(ev) {
			if (!ev) {
				Object.keys(eventListeners).forEach(eventName => proxy.off(eventName));
			}
			if (eventListeners[ev]) {
				emitter.off(ev, ...eventListeners[ev]);
			}
			return proxy;
		}
	});
};



// WEBPACK FOOTER //
// ./node_modules/smart-table-events/index.js